<template>
  <div class="flex flex-col justify-start items-center">
    <h1>Exhibitor Terms and Conditions</h1>
    <p>
      Thanks for deciding to book an expo space at the Careers Expo (Expo), we
      look forward to seeing you there!
    </p>
    <p>
      By making a booking for a stand or booth at the Expo of your choice of
      venue (Venue), and paying a fee for the stand or booth (Exhibition Fee),
      you (the Exhibitor) are entering into an agreement between the Expo
      Management Company Calibre and Associates (Organiser) and agree to the
      following terms, which include by reference the Exhibitor Compendiums as
      found on the Careers Expo website:
    </p>
    <ol>
      <li>
        <h3 class="text-expo_red">How do I book?</h3>
        <ol>
          <li>
            All Bookings must be made on the Exhibitor Application Form on-line
            and will be confirmed within 5 business days via a confirmation
            e-mail.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">What are the payment terms?</h3>
        <ol>
          <li>
            For bookings made prior to 1 January 2025, an invoice will be issued
            with full payment due 20th of the month following the date of
            invoice.
          </li>
          <li>
            Bookings made between 1 January 2025 and 31 March 2025 a 50% deposit
            is required 7 days after booking/invoice, with the full balance due
            20th month following the date of invoice. (If balance is not
            received by this due date, and no prior arrangements have been made,
            the reserved exhibition space deposit will be forfeited and the
            space made available for resale.
          </li>
          <li>
            All bookings made after 1 April 2025 require full payment 7 days
            from the date of booking /invoice.
          </li>
          <li>
            Exclusions from Exhibitor Fee: The Exhibitor Fee does not include
            insurance, cleaning, loading and handling of equipment, staff,
            telephones, exhibit dressing, advertising or promotional material.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">
          What happens if I want to cancel a booking?
        </h3>
        <ol>
          <li>
            Cancellations/Refunds: All cancellations must be submitted in
            writing. No refunds are granted after 28 February 2025. In the event
            of an Act of God, natural disaster, fire, rain, wind, storm or any
            other unforeseen event or catastrophe, the Organiser is not obliged
            to refund any part of Exhibitor Fee or other monies. All refunds are
            at the discretion of the Organiser.
          </li>
          <li>
            Cancellation to be made in writing: Any cancellations must be made
            in writing or by email to Organiser at the address specified on the
            website.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">How are booths allocated?</h3>
        <ol>
          <li>
            Allocation of booths: Booths will be allocated on a 'first come,
            first served' basis.
          </li>
          <li>
            Alteration of Floorplan: The Organiser reserves the right to amend
            the floorplan or alter the exact location of the booths within the
            floorplan to accommodate sales e.g. where an Exhibitor books more
            than 4 (four) booths to avoid conflicts with other exhibitors. The
            Organiser will endeavour to consult with the exhibitors who are
            directly affected whenever possible and the Exhibitor undertakes to
            agree to such alteration(s).
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">
          What are the specifications of the Expo booth/space?
        </h3>
        <ol>
          <li>
            Booth sizes vary amongst venues. Please refer to the regional floor
            plan for booth size. Booths include Velcro receptive wall panels and
            power. Carpet is supplied in some venues, while others itilise the
            venue flooring. Final flooring applications will be advised in the
            exhibitors compendium
          </li>
          <li>
            Special booth/stand requirements: The Exhibitor must advise the
            Organiser of any special requirements at least 3 weeks prior to the
            Expo date. All special requirements are subject to approval from the
            Organisers.
          </li>
          <li>
            Booth shell scheme colours: The shell scheme is black. Exhibitors
            wishing to use other colours need to book and pay directly with the
            Organiser's nominated display company, at the sole cost of the
            Exhibitor. Further information is available on the Careers Expo
            website.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">What are my obligations as an exhibitor?</h3>
        <ol>
          <li>
            Responsibility: It is the Exhibitor's responsibility to educate
            attendees about the industry/product/service they represents in the
            most positive, competent, articulate and professional manner
            possible. Business casual attire is appropriate (we recommend
            wearing comfortable shoes).
          </li>
          <li>
            Not Permitted: Alcohol, illegal drugs, smoking, disruptive and/or
            disrespectful behaviour are prohibited.
          </li>
          <li>
            No “Booth Buddies”: Booth Buddies are people (family, friends,
            business partners, colleagues, associates, etc.) who are not signed
            up to exhibit at the Expo but hang out at or near the Exhibitor's
            booth with the intention of selling products or services. Booth
            Buddies are not permitted at the Expo.
          </li>
          <li>
            General: The Exhibitor must ensure that:
            <ol>
              <li>
                the booth is fully staffed and continually kept open throughout
                the course of the Expo;
              </li>
              <li>walkways are kept clear at all times;</li>
              <li>
                the space is kept clean and tidy and free from rubbish at all
                times;
              </li>
              <li>
                business is conducted in an appropriate manner from the booth
                considering the Venue, Organiser, other exhibitors and visitors.
              </li>
            </ol>
          </li>

          <li>
            Arrangement of displays: The Exhibitor is required to arrange
            his/her/its displays so as to not obstruct the general view or
            conceal other exhibits. No signs or banners are to be placed outside
            of the booth assigned to each exhibitor. Exhibit personnel may not
            stand in the aisles or hand out materials, flyers or bags in the
            aisles of the Expo and must do so only within the allocated booth
            area.
          </li>
          <li>
            Disturbance: Loud speakers, radios, televisions or the operation of
            any machinery or equipment which is of sufficient volume to be
            distracting to neighbouring exhibitors or Expo attendees are not
            permitted. Public address systems used to attract the attention of
            visitors passing near the Exhibitor's booth are also not permitted.
          </li>
          <li>
            Fund Raising: Fund raising for non-profit groups or charities will
            be permitted only with written permission from the Organiser.
          </li>
          <li>
            Displaying Products: If the Exhibitor is displaying products or any
            material which is determined, in the Organiser's discretion, to be
            inappropriate, including, for example, materials that are offensive,
            disparaging or discriminatory will be asked to remove its products
            or exhibit.
          </li>
          <li>
            Materials and Packing: All materials used in the Expo must be
            non-flammable and non-conforming materials must be removed
            immediately from the Venue. All packing containers are to be removed
            from the Expo floor and must not be stored under tables or behind
            displays.
          </li>
          <li>
            Liquor Laws: As the Expo is aimed at visitors who may be under 18,
            and in order to comply with Venue Liquor Licensing requirements, no
            alcohol is served from the booth or included in any prize draws.
          </li>
          <li>
            No Substitution/Sublease: The Exhibitor may not substitute
            him/her/itself or sublease booth space.
          </li>
          <li>
            Exhibitor responsible for own property: The property of the
            Exhibitor is deemed to be under his/her/its custody, control and
            oversight at all times, including in transit to and from the Expo
            and within the confines of their booth. The booth, materials,
            displays and equipment should not be left unattended at any time.
            The Exhibitor is wholly responsible for the security of his/her/its
            materials during set up, Expo hours and pack out/dismantling.
          </li>
          <li>
            Liability: The Organiser accepts no responsibility whatsoever for
            any loss of or damage to or theft of property (including materials,
            displays and equipment) belonging to the Exhibitor.
          </li>
        </ol>
      </li>

      <li>
        <h3 class="text-expo_red">Set-up/pack-in and pack-out/dismantling</h3>
        <ol>
          <li>
            Set-up: Set-up times will be advised in the exhibitor compendium for
            each venue. If the Exhibitor does not arrive (or call the Organiser)
            by 9:30am on the first day of the event, his/her/its booth space(s)
            will be given to a wait-listed exhibitor and the Exhibitor will not
            receive a refund, unless prior arrangements have been made with the
            Organiser. The Exhibitor must take care when installing/dismantling
            his/her/its equipment and stand as not to cause damage to the Venue
            carpet, walls, floor and booths, including all panels, fascia and
            lighting.
          </li>
          <li>
            Dismantling: Booth dismantle does not occur until after the Expo
            closes; exhibitors must not disrupt the Expo by dismantling early.
          </li>
          <li>
            Pack Out deadline: All exhibits must be packed out, 2 hours after
            closure on the final day of the Expo (unless prior arrangements are
            made with the Organisers).
          </li>
          <li>
            Couriers and transportation of equipment etc. The Exhibitor is
            responsible for arranging couriers and transportation of exhibition
            equipment and exhibits to the Expo.
          </li>
          <li>
            Storage of equipment etc. The Exhibitor must make his/her/its own
            arrangements for storage of exhibits and equipment prior, during and
            after the Expo.
          </li>
          <li>
            Responsibility for loss/damage if caused: The Exhibitor will be
            solely responsible for the cost of remedying any damage and repairs
            howsoever caused to the Venue carpet, walls, floor and. All property
            damaged or destroyed by an Exhibitor must be replaced to its
            original condition at the expense of the Exhibitor.
          </li>
        </ol>
      </li>

      <li>
        <h3 class="text-expo_red">What are my health & safety obligations?</h3>
        <ol>
          <li>
            Legal Compliance: All exhibitions must meet current Building Act
            2004, Health & Safety in Employment Act 1992 and New Zealand Fire
            Safety regulations.
          </li>
          <li>
            Venue Compliance: The Exhibitor must, at all times, comply with the
            Venue's regulations and policies including for example a strict a no
            smoking and any other laws applying to the Venue.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">What insurance must I have?</h3>
        <ol>
          <li>
            Exhibitor to indemnify: By completing and submitting the Exhibitor
            Application Form, the Exhibitor agrees to indemnify and hold
            harmless the Organiser and the Venue from all claims, demands,
            damages, and liability of any kind, including loss, damage or
            destruction of property, breach of contract, injury, negligence,
            abuse or wilful misconduct on the part of any party.
          </li>
          <li>
            Organiser does not insure: Neither the Organiser nor the Venue
            owners provides insurance for the benefit of exhibitors. Exhibitors
            who wish to carry insurance on their property or for any other
            purpose must do so at their own expense.
          </li>
          <li>
            Exhibitor to insure: The Exhibitor, at its sole expense, must take
            out all necessary insurance, including Public Liability insurance
            for a minimum indemnity of $1,000,000.00. The Organiser may ask for
            a copy of the insurance policy at any time.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">
          How will the organiser use my personal information?
        </h3>
        <ol>
          <li>
            Privacy Act 1993: The Organiser complies with the Privacy Act 1993.
            Booking a space deems consent to receive promotional material about
            the Expo and the Organiser's products. The Organiser will only pass
            on Exhibitor's information to third parties for the sole purpose of
            organising the Expo. If the Exhibitor wishes to opt out of receiving
            such information please indicate on the Exhibitor Booking
            Application.
          </li>
          <li>
            Access to personal information: All personal information provided by
            exhibitors on the Exhibitor Application Form will be held by the
            Organiser. Under the Privacy Act 1993, exhibitors have the right to
            access and correct their personal information.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">
          What marketing of the expo will be done by the organisers?
        </h3>
        <ol>
          <li>
            Official Programme: The Organiser may produce an official programme
            listing exhibitors for the Expo and will feature all exhibitors on
            the Expo website. The Organiser accepts no responsibility for any
            misdescription or any other error. The Organiser gives no warranty
            as to the type or extent of the promotion of the Expo or as to
            attendance numbers at any Venue.
          </li>
          <li>
            Consent to use image: By making a booking for a space the Exhibitor
            gives consent to the Organiser to take and use photographs, images
            and any video footage of the Exhibitor, or the space during the Expo
            for any of the Organiser's promotional purposes in perpetuity in any
            media without any payment to the Exhibitor.
          </li>
          <li>
            Exhibitor use of photos etc. for marketing purposes: The Exhibitor
            is permitted to take a reasonable amount of photographs for
            his/her/its own promotional and marketing use provided that the
            Exhibitor does not infringe the Organiser's intellectual property
            rights it holds in connection with the Expo.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">
          What happens if I breach these terms and conditions?
        </h3>
        <ol>
          <li>
            Unsuitable exhibits: The Organiser has the right to prohibit,
            prevent or remove any part of any exhibit deemed unsuitable or
            inappropriate for the purpose of the Expo.
          </li>
          <li>
            Failure to comply: In the case of any failure of any Exhibitor to
            comply with these terms and conditions, the Organiser may cancel the
            Exhibitor's booking or may, during the staging of the Expo, eject
            any Exhibitor from the Venue. No refund or compensation will be
            payable to the Exhibitor if cancellation or expulsion occurs.
          </li>
          <li>
            Consequences of ejection: If the Exhibitor is ejected from the Expo
            Venue, or their booking is cancelled, the Exhibitor will then be
            prohibited from occupying any booth space. If the Exhibitor is at
            the time occupying a booth, the Exhibitor must immediately remove
            all his/her/its exhibits from the Venue in accordance with the
            Organiser's directions. The Exhibitor will be responsible for all
            costs incurred by the Exhibitor and the Organiser in enforcing this
            clause 12.
          </li>
        </ol>
      </li>
      <li>
        <h3 class="text-expo_red">General</h3>
        <ol>
          <li>
            Governing Law: These terms and conditions are governed by the laws
            of New Zealand.
          </li>
          <li>
            Intellectual property: Calibre Associates or The Company as
            applicable, own, or exclusively license in New Zealand, all
            intellectual property rights (including patents, copyright, designs
            (registered or not), trademarks (registered or not) and service
            marks) in or relating to the Products and the naming rights to the “
            New Zealand Careers Expo”. The Exhibitor agrees at all times to
            respect the validity and ownership of such rights and the goodwill
            attached to those rights and not to do or omit to do any act or
            thing or allow any act or thing to occur which may put in jeopardy
            the validity or ownership of those rights.
          </li>
          <li>
            Exhibitor liable for losses: The Exhibitor will be liable to the
            Organiser for all losses, unpaid accounts, interest, damages, costs,
            charges, fees and expenses incurred by the Organiser as a result of
            the Exhibitor failing to comply with non-assignment provisions of
            these terms and conditions.
          </li>
          <li>
            Alterations to terms and conditions: The Organiser reserves the
            right to alter these terms and conditions at any time and for any
            reason.
          </li>
          <li>
            Alterations to dates of Expo: The Organiser reserves, in its
            absolute discretion, the right to alter the dates of the Expo and
            will use all reasonable endeavours to provide the exhibitors with
            reasonable prior notice of the change of date and will work with
            exhibitors to accommodate the change. No refunds will be given to
            Exhibitors for any change of date.
          </li>
        </ol>
      </li>
    </ol>
    <h5>
      ACCEPTANCE: The Exhibitor has read the terms and conditions and
      understands that this agreement is legally binding between the Organiser
      and the Exhibitor.
    </h5>
    <h5>
      Thank you for reading. By agreeing to these terms and conditions you will
      help to ensure a great Careers Expo experience for everyone involved.
    </h5>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
ol {
  counter-reset: item;
}
li {
  display: block;
  padding: 8px;
}
li:before {
  content: counters(item, '.') ' ';
  counter-increment: item;
  position: absolute;
  left: 6%;
}
ol li {
  margin-left: 8px;
}
ol li ol li:before {
  left: 8%;
}

ol li ol li {
  margin-left: 32px;
}
</style>
